import { render, staticRenderFns } from "./perfil-menu.vue?vue&type=template&id=c8349d66"
import script from "./perfil-menu.vue?vue&type=script&lang=js"
export * from "./perfil-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports